// Phase 7 D3 — Track C T-C1. SettingsShell layout.
//
// Two-column shell on desktop (220px nav + flexible main); single-column
// on mobile (top pill strip + main below). Renders <Outlet/> for the five
// sub-routes wired in `app/router.tsx`.
//
// The settings page is itself rendered inside <AppShell/> (so the global
// nav, theme toggle, user menu, and skip-link all stay available). This
// shell is therefore strictly the inner-page chrome — not a top-level
// navigation surface.
//
// Tab order (Q-1): natural document order — every nav link first, then
// the Outlet's main content. No tabIndex overrides.

import { Outlet } from 'react-router-dom';
import { copy } from '@dailydeck/shared/copy';
import { SettingsNav } from './SettingsNav.js';

export function SettingsShell(): JSX.Element {
  return (
    <div data-testid="settings-shell" className="flex flex-col gap-6">
      <header>
        <h1 className="text-title-1 font-semibold text-text-primary">
          {copy.settings.shell.title}
        </h1>
      </header>
      <div className="flex flex-col gap-4 md:flex-row md:gap-8">
        <SettingsNav />
        <section
          className="min-w-0 flex-1"
          aria-labelledby="settings-section-heading"
        >
          <Outlet />
        </section>
      </div>
    </div>
  );
}
